import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowUpRightComponent } from "./med-icon-arrow-up-right.component";

@NgModule({
  declarations: [
    MedIconArrowUpRightComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowUpRightComponent,
  ],
})
export class MedIconArrowUpRightModule { }
